var Reverb = window.Reverb || {};

Reverb.MobileImageZoom = (function () {
  var thumb_selector = '.fotorama__active.fotorama__loaded--img img';
  var photoswipe_active = false;
  var active_thumbnail,
    photoswipe_element;

  function init() {
    if (Reverb.MobileDetection.isMobileBrowser()) {
      bindToThumbnail();
    }
  }

  function bindToThumbnail() {
    $(document).on('tap', thumb_selector, function (e) {
      // Check if the tapped fotorama image is in a photoswipe-enabled fotorama gallery and that gallery is not open
      if ($(this).closest('.fotorama[data-photoswipe=true]').length > 0 && !photoswipe_active) {
        active_thumbnail = $(this);
        photoswipe_active = true;
        active_thumbnail.parent().spin();
        var fotorama_element = active_thumbnail.closest('.fotorama');
        var fotorama_data = fotorama_element.data('fotorama');
        if (fotorama_element.data('gallery-id')) {
          var gallery_id = active_thumbnail.closest('.fotorama').data('gallery-id');
          photoswipe_element = $('.pswp#' + gallery_id)[0];
        } else {
          photoswipe_element = $('.pswp')[0];
        }
        naturalDimensions(fotorama_data.activeFrame.full, function () {
          var pswp_items = [{ src: fotorama_data.activeFrame.full, w: this.width, h: this.height }];
          initGallery(photoswipe_element, pswp_items, active_thumbnail);
        });
      }
    });
  }

  function initGallery(photoswipe_element, pswp_items) {
    var gallery = new window.PhotoSwipe(photoswipe_element, window.PhotoSwipeUI_Default, pswp_items, { getThumbBoundsFn: getThumbBounds, tapToToggleControls: false });
    gallery.init();
    gallery.listen('destroy', function () {
      photoswipe_active = false;
    });
    gallery.listen('imageLoadComplete', function (index, item) {
      active_thumbnail.parent().stopSpinner();
    });
  }

  function naturalDimensions(img_src, callback) {
    var temp_img = new Image();
    temp_img.onload = callback;
    temp_img.src = img_src;
  }

  function getThumbBounds() {
    var thumbnail = active_thumbnail[0];
    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
    var rect = thumbnail.getBoundingClientRect();
    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
  }

  return {
    init: init
  };
})();

$(Reverb.MobileImageZoom.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/mobile_web_image_zoom.js